import { useState } from 'react';
import { Alert, Box, Button, TextField, Typography } from '@mui/material';
import { getAniListContinue, normalizeAniListUsername } from '../../tracking/AniListContinue.ts';
import { trackerManager } from '../../tracking/TrackerManager.ts';

export const aniListProfileKey = 'yomiri-anilist-public-profile';
export function AniListSettings() {
  const [saved, setSaved] = useState(() => localStorage.getItem(aniListProfileKey) || '');
  const [username, setUsername] = useState(saved);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const syncNow = async () => {
    if (!saved) return;
    setBusy(true); setError(''); setNotice('');
    try {
      await Promise.all([getAniListContinue(saved, { force: true }), trackerManager.flushDelayedQueue()]);
      window.dispatchEvent(new Event('yomiri-anilist-profile-changed'));
      setNotice('Sincronización completada. Tu lista y el progreso pendiente están actualizados.');
    } catch (cause) { setError(cause instanceof Error ? cause.message : 'No se pudo sincronizar ahora.'); }
    finally { setBusy(false); }
  };
  return <Box sx={{ color: 'var(--y-onSurface)', maxWidth: 480 }}>
    <Typography component="h2" sx={{ fontSize: 22, fontWeight: 600, mb: 1 }}>AniList</Typography>
    <Typography sx={{ fontSize: 14, color: 'var(--y-onSurfaceVariant)', mb: 3 }}>Mostrá tus animes y mangas en curso en Inicio usando tu lista pública. No necesitás compartir tu contraseña.</Typography>
    <Box component="form" onSubmit={async event => {
      event.preventDefault(); setBusy(true); setError(''); setNotice('');
      try {
        const name = normalizeAniListUsername(username);
        await getAniListContinue(name);
        localStorage.setItem(aniListProfileKey, name); setSaved(name); setUsername(name);
        window.dispatchEvent(new Event('yomiri-anilist-profile-changed'));
        setNotice('Lista comprobada. Ya podés verla en Inicio.');
      } catch (cause) { setError(cause instanceof Error ? cause.message : 'No se pudo comprobar tu lista.'); }
      finally { setBusy(false); }
    }}>
      <TextField label="Usuario o URL del perfil de AniList" helperText="Ejemplo: https://anilist.co/user/tu-usuario/. No uses tu correo ni tu nombre de Yomiri." fullWidth value={username} onChange={event => setUsername(event.target.value)} disabled={busy} slotProps={{ htmlInput: { maxLength: 250 } }} />
      <Box sx={{ display: 'flex', gap: 1, my: 2 }}><Button type="submit" variant="contained" disabled={busy || !username.trim()}>{busy ? 'Comprobando…' : saved ? 'Actualizar conexión' : 'Conectar lista pública'}</Button>
        {saved && <Button type="button" variant="outlined" disabled={busy} onClick={() => void syncNow()}>{busy ? 'Actualizando…' : 'Actualizar lista'}</Button>}
        {saved && <Button disabled={busy} onClick={() => { localStorage.removeItem(aniListProfileKey); setSaved(''); setUsername(''); setError(''); setNotice('Lista desconectada.'); window.dispatchEvent(new Event('yomiri-anilist-profile-changed')); }}>Desconectar</Button>}
      </Box>
    </Box>
    {error && <Alert severity="warning">{error}</Alert>}{notice && <Alert severity="info">{notice}</Alert>}
    <Typography sx={{ fontSize: 12, color: 'var(--y-onSurfaceVariant)', mt: 2 }}>La conexión se guarda en este navegador. Las listas privadas requieren autorización de AniList; esta conexión pública no actualiza tu progreso.</Typography>
  </Box>;
}
